import _get from 'lodash/get';
export default {
  getInventory: state => _get(state, 'inventory', {})
};